const MB_TO_BYTES = 1024 * 1024;

//Photo notes and inventory
export const MAX_TOTAL_SIZE_ROOM_PHOTO_MB = 200; // 200MB
export const MAX_TOTAL_SIZE_ROOM_PHOTO_IN_BYTES =
  MAX_TOTAL_SIZE_ROOM_PHOTO_MB * 1024 * 1024; // 200MB

// Other expenses
export const MAX_TOTAL_SIZE_OTHER_EXPENSESS_MB = 20; // 20MB

//Job uploads
export const MAX_TOTAL_SIZE_JOB_UPLOADS_MB = 50;
export const MAX_TOTAL_SIZE_JOB_UPLOADS_IN_BYTES =
  MAX_TOTAL_SIZE_JOB_UPLOADS_MB * MB_TO_BYTES; // 20MB

//Email attachments
export const MAX_TOTAL_SIZE_EMAIL_ATTACHMENTS_MB = 20;
export const MAX_TOTAL_SIZE_EMAIL_ATTACHMENTS_IN_BYTES =
  MAX_TOTAL_SIZE_EMAIL_ATTACHMENTS_MB * MB_TO_BYTES; // 20MB
export const MAX_FILES_COUNT_EMAIL_ATTACHMENTS = 10;

//Task attachments
export const MAX_TOTAL_SIZE_TASK_ATTACHMENTS_MB = 50;
export const MAX_TOTAL_SIZE_TASK_ATTACHMENTS_IN_BYTES =
  MAX_TOTAL_SIZE_TASK_ATTACHMENTS_MB * MB_TO_BYTES; // 20MB

// Moisture readings
export const MAX_TOTAL_SIZE_MOISTURE_READINGS_MB = 50;

//Floor plan
export const MAX_TOTAL_SIZE_FLOOR_PLAN_MB = 50;

//Letterhead
export const MAX_TOTAL_SIZE_LETTERHEAD_MB = 1;

// Other Expenses
export const MAX_TOTAL_SIZE_OTHER_EXPENSES_PHOTOS_MB = 20;

export const getFileSize = (selectedFiles: File[]) => {
  const totalSize = selectedFiles.reduce(
    (total, file) => total + file?.size,
    0
  );

  return Number(totalSize / 1024 / 1024).toFixed(2);
};

export const isSizeExceeded = (
  selectedFiles: File[],
  customMaxSizeInMB?: number
) => {
  const totalSize = selectedFiles.reduce(
    (total, file) => total + file?.size,
    0
  );
  if (customMaxSizeInMB) {
    return totalSize > customMaxSizeInMB * MB_TO_BYTES;
  } else {
    return totalSize > MAX_TOTAL_SIZE_ROOM_PHOTO_IN_BYTES;
  }
};

export const isSizeExceededEmailDocuments = (
  selectedFiles: File[],
  selectedDocumentsDetails?: { fileName: string; fileSize: number; id: string }[],
  customMaxSizeInMB?: number
) => {
  const totalDeviceDocumentsSize = selectedFiles.reduce(
    (total, file) => total + file?.size,
    0
  );
  const totalSelectedDocumentsSize = selectedDocumentsDetails?.reduce(
    (total, doc) => total + doc.fileSize,
    0
  ) || 0;
  const totalSize = totalDeviceDocumentsSize + totalSelectedDocumentsSize;

  if (customMaxSizeInMB) {
    return totalSize > customMaxSizeInMB * MB_TO_BYTES;
  } else {
    return totalSize > MAX_TOTAL_SIZE_ROOM_PHOTO_IN_BYTES;
  }
};

export const isFileCountExceededEmailDocuments = (
  selectedFilesCount: number,
  selectedDocumentsCount: number,
  maxCount: number = MAX_FILES_COUNT_EMAIL_ATTACHMENTS
) => selectedFilesCount + selectedDocumentsCount > maxCount;